import { Mark } from '@tiptap/core'

const TiptapSelection = Mark.create({
  name: 'selection',

  addOptions () {
    return {
      selection: ['selection']
    }
  },

  addAttributes () {
    return {
      selection: {
        default: 'selection'
      }
    }
  },

  parseHTML () {
    return this.options.selection.map(() => ({
      tag: 'selection'
    }))
  },

  renderHTML ({ HTMLAttributes }) {
    return ['selection', HTMLAttributes, 0]
  },

  addCommands () {
    return {
      selection: attrs => ({ commands }) => {
        if (!attrs) {
          return commands.unsetMark(this.name)
        }

        return commands.setMark(this.name, attrs)
      }
    }
  }
})

export default TiptapSelection
